import { render, staticRenderFns } from "./DatasetMiscInfo.vue?vue&type=template&id=aef8814a"
import script from "./DatasetMiscInfo.vue?vue&type=script&setup=true&lang=ts"
export * from "./DatasetMiscInfo.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports